import React, {useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import VisibilityIcon from "@material-ui/icons/Visibility";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import AlarmOnIcon from "@material-ui/icons/AlarmOn";
import Chip from "@material-ui/core/Chip";
import CardActionArea from "@material-ui/core/CardActionArea";
import {
  TRANSLATE,
  resizeImage,
  filterCategory,
  convertTime,
} from "../utils/helper";
import clsx from "clsx";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import BrightnessHighIcon from "@material-ui/icons/BrightnessHigh";
import EventIcon from "@material-ui/icons/Event";
import { connect } from "react-redux";
import CategoryOutlinedIcon from "@material-ui/icons/CategoryOutlined";
import SettingsBackupRestoreOutlinedIcon from "@material-ui/icons/SettingsBackupRestoreOutlined";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import DraggableWrapper from './DraggableWrapper';
import CardActions from '@material-ui/core/CardActions';
import ControlCameraOutlinedIcon from '@material-ui/icons/ControlCameraOutlined';
import Button from '@material-ui/core/Button';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import SyncOutlinedIcon from '@material-ui/icons/SyncOutlined';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import getPrType from "src/utils/prType";
const prTypes = getPrType();

const placeholderImgSrc = `${process.env.PUBLIC_URL}img/placeholder.jpg`;

const icons = {
  newest: FiberNewIcon,
  pageview: VisibilityIcon,
  realtime: AlarmOnIcon,
};

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 345,
    boxShadow: "none",
    "&.special": {
      backgroundColor: "#ffd44e",
      "& $media": {
        borderRadius: "0px",
      },
      "& $content": {
        padding: "16px",
        backgroundColor: "#ffffff",
      },
    },
    "&.top-1 h6": {
      marginTop: "15px",
      marginBottom: "8px",
      fontSize: "24px",
      letterSpacing: "-0.48px",
      lineHeight: "31.2px",
    },
    "&.top-2 h6": {
      fontSize: "20px",
      marginTop: "15px",
      letterSpacing: "-0.4px",
      lineHeight: "26px",
    },
    "&.top-1": {
      maxWidth: "610px",
    },
    
    "&.top-2": {
      maxWidth: "238.56px",
    }
  },
  horCard: {
    display: "flex",
    alignItems: "flex-start",

    "& $media": {
      width: 268,
      height: 166.08,
      paddingTop: "0",
      position: "relative",
    },
    "& $content": {
      flex: "1 0 1px",
      padding: "0px 0px 0px 16px",
    },
  },
  horCardMobile: {
    display: "flex",
    alignItems: "flex-start",

    "& $media": {
      width: 260,
      height: 163,
      paddingTop: "0",
      position: "relative",
    },
    "& $content": {
      flex: "1 0 1px",
      padding: "0px 0px 0px 0px",
    },
  },
  media: {
    height: 0,
    paddingTop: "62.5%", // 16:10
    borderRadius: "8px",
    overflow: "hidden",
    position: "relative",
  },
  mediaMobile:{
    height: "100%",
    width: "100%",
    
    borderRadius: "8px",
    overflow: "hidden",
    position: "absolute",
  },
  thumbHolderMobile:{
    paddingBottom: "62.5%", // 16:10
    position: "relative",
    borderRadius: "8px",
    overflow: "hidden",
  },
  thumbMobile:{
    width: "47.5%",
    position: "relative",
    borderRadius: "8px",
    overflow: "hidden",
  },
  sapoMobile:{
    width: "52.5%",
    marginLeft: "15px",
  },
  verThumb: {
    "& $media": {
      paddingTop: "160%", // 10:16
    },
  },
  content: {
    padding: "0px 0px",
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: "600",
    color: "#1D232E",
    letterSpacing: "-0.4px",
    overflow: "hidden",
    lineHeight: "26px",
    fontSize: "20px",
    paddingRight: "10px",
  },
  category: {
    fontWeight: "600",
    fontSize: "14px",
    color: "#FF474E",
    letterSpacing: "-0.02em",
    fontFamily: 'Inter',
    margin: "0 20px 0 0",
  },
  publishedAt: {
    fontSize: "14px",
    fontFamily: 'Inter',
    letterSpacing: "-0.02em",
    color: "#92979E",
    marginBottom: "0px",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  chiplist: {
    display: "flex",
    marginTop: "5px",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  chiplistMobile: {
    display: "flex",
    marginTop: "10px",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  mlAuto: {
    marginLeft: "auto",
  },
  btnChangePostion:{
    position: "relative",
    marginTop: "-44px",
  }
}));

const ActionsCard = ({ tile, switchPositionTile, handleSwitchPosition, className }) => {
  const classes = useStyles();
  const [switchPositionStatus, setSwitchPositionStatus] = useState(false);

  const handleOnClickAway = () => {
    console.log({ switchPositionTile: switchPositionTile.id, tile: tile.id });

    if (switchPositionTile && switchPositionTile.id === tile.id) {
      console.log("handleOnClickAway", switchPositionStatus);
    }

    // if (switchPositionStatus) {
    //   handleSwitchPosition && handleSwitchPosition(true, tile);
    // }
  };

  if (tile.post && tile.post.pr_type !== "0") {
    return (<></>);
  }

  return (
    <CardActions disableSpacing className={classes.btnChangePostion}>
      {/* <ClickAwayListener onClickAway={handleOnClickAway}> */}
      {switchPositionTile && tile && switchPositionTile.id !== tile.id ? (
        <Button
          variant="outlined"
          color="default"
          className={classes.mlAuto}
          startIcon={<CheckOutlinedIcon />}
          onClick={() => {
            handleSwitchPosition(false, tile);
            setSwitchPositionStatus(false);
          }}
        >
          Chọn
        </Button>
      ) : (
        <>
          {switchPositionTile && tile && switchPositionTile.id === tile.id ? (
            <Button
              variant="outlined"
              color="default"
              className={classes.mlAuto}
              startIcon={<SyncOutlinedIcon />}
              onClick={() => {
                handleSwitchPosition(true, tile);
                setSwitchPositionStatus(false);
              }}
            >
              Huỷ
            </Button>
          ) : (
            <Button
              variant="outlined"
              color="default"
              className={classes.mlAuto}
              startIcon={<SyncOutlinedIcon />}
              onClick={() => {
                handleSwitchPosition(true, tile);
                setSwitchPositionStatus(true);
              }}
            >
              Đổi vị trí
            </Button>
          )}
        </>
      )}
      {/* </ClickAwayListener> */}
    </CardActions>
  );
};

const ManualPost = ({ className = "", tile, index, openSetting, config, switchPositionTile, handleSwitchPosition, showCate = true, showTime = true, showDescription = true }) => {
  const classes = useStyles();
  const { img_hor, title, primary_category, publishedAt, description, have_video } = tile.post;
  const IconComponent = icons[tile.autoGetBy];
  const timeAgo = new Date() - new Date(publishedAt);
  return (
    <>
    <BrowserView>
      <Card className={clsx(classes.root, {
          [tile.className]: tile.className
        })}>
          <CardActionArea
            onClick={() => openSetting(tile, index)}
            className={clsx({
              [classes.horCard]: tile.cardType === "hor-card",
              [classes.verThumb]: (tile.thumbType === "ver-thumb"),
            })}
          >
            <CardMedia
              className={(have_video ? "have_video " : "") + classes.media}
              image={resizeImage(
                tile.thumbType === "ver-thumb"
                  ? tile.post.img_ver
                  : tile.post.img_hor,
                tile.thumbSize || 300
              )}
              title={title}
            />
            <CardContent className={classes.content}>
              
              <Typography variant="body2" component="h6" className={classes.title}>
                {title}
              </Typography>
              
              <div className="d-flex align-items-end my-2 cate-time">
                {showCate &&
                  <p className={classes.category}>
                    {filterCategory(config, primary_category)}
                  </p>
                }
                {showTime &&
                  <p className={classes.publishedAt} dangerouslySetInnerHTML={{ __html: convertTime(publishedAt) }}>
                  </p>
                }
              </div>
              {showDescription &&
                <div className="post-sapo">
                  {description}
                </div>
              }

              <div className={isMobile ? classes.chiplistMobile : classes.chiplist}>
                <Chip label={index + 1} />
                <Chip
                  avatar={<Avatar>M</Avatar>}
                  label="Cố định"
                  color="secondary"
                />
                {tile.post.pr_type && tile.post.pr_type !== "0" && (
                  <Chip
                    icon={<BrightnessHighIcon />}
                    label={`${prTypes.find(el => (el.value !== '0' && el.value === tile.post.pr_type)).label}`}
                  />
                )}
                {tile.expiredAt && (
                  <>
                    <Chip
                      icon={<EventIcon />}
                      label={convertTime(tile.expiredAt)}
                    />
                    <Chip
                      icon={<IconComponent />}
                      label={TRANSLATE[tile.autoGetBy]}
                    />

                    {tile.tags && tile.tags.length > 0 && (
                      <>
                        {tile.tags.map((tag) => (
                          <Chip
                            key={`tag-${tag.label}`}
                            icon={<LocalOfferOutlinedIcon />}
                            label={tag.label}
                          />
                        ))}
                      </>
                    )}

                    {tile.category && (
                      <Chip
                        icon={<CategoryOutlinedIcon />}
                        label={tile.category.name}
                      />
                    )}

                    {tile.autoGetBy === "pageview" && tile.pageviewDuration && (
                      <Chip
                        icon={<SettingsBackupRestoreOutlinedIcon />}
                        label={`${tile.pageviewDuration} ngày trước`}
                      />
                    )}
                    {tile.duplicatePermission && (
                      <Chip icon={<FileCopyIcon />} label="Cho phép trùng" />
                    )}
                  </>
                )}
                {tile.nextPost && (
                  <p className="text-sm">Tiếp theo: {tile.nextPost.title}</p>
                )}
              </div>
            </CardContent>
          </CardActionArea>
        </Card>
    </BrowserView>
    <MobileView>
      <Card className={clsx(classes.root, {
          [tile.className]: tile.className
        })}>
          <CardActionArea
            onClick={() => openSetting(tile, index)}
            className={clsx({
              [classes.horCardMobile]: tile.cardType === "hor-card",
              [classes.verThumb]: (tile.thumbType === "ver-thumb" && tile.className.indexOf("top-2") < 0),
            })}
          >
          {(tile.className && (tile.className.indexOf("top-1") >= 0 || tile.className.indexOf("top-2") >= 0 || tile.className.indexOf("thumb-radius-0") >= 0 || tile.className.indexOf("special") >= 0))  &&
            <CardMedia
                className={(have_video ? "have_video " : "") + classes.media}
                image={resizeImage(
                  tile.thumbMobileType === "ver-thumb"
                    ? (tile.className.indexOf("top-2") >= 0 ? tile.post.img_hor : tile.post.img_ver)
                    : tile.post.img_hor,
                  tile.thumbSize || 300
                )}
                title={title}
              />
          }
            
            <CardContent className={classes.content}>
              
              <Typography variant="body2" component="h6" className={classes.title}>
                {title}
              </Typography>

              <div className="d-flex align-items-end my-2 cate-time">
                <p className={classes.category}>
                  {filterCategory(config, primary_category)}
                </p>

                <p className={classes.publishedAt} dangerouslySetInnerHTML={{ __html: convertTime(publishedAt) }}>
                </p>
              </div>
              {tile.className && tile.className != "top-1" && tile.className.indexOf("top-2") < 0 && tile.className.indexOf("thumb-radius-0") < 0 && tile.className.indexOf("special") < 0 &&
                <div className="d-flex justify-content-between align-items-start mt-2">
                  <div className={classes.thumbMobile}>
                    <div className={classes.thumbHolderMobile}>
                      <CardMedia
                        className={((have_video) ? "have_video " : "") + classes.mediaMobile}
                        image={resizeImage(
                                tile.thumbMobileType === "ver-thumb"
                                  ? tile.post.img_ver
                                  : tile.post.img_hor,
                                tile.thumbSize || 300
                              )
                        }
                        title={title}
                      />
                    </div>
                  </div>
                  {showDescription && (
                    <div className={classes.sapoMobile + " post-sapo"}>
                      {description}
                    </div>
                  )}
                </div>
              }
              {tile.className && (tile.className == "top-1" || tile.className.indexOf("top-2") >= 0 || tile.className.indexOf("thumb-radius-0") >= 0 || tile.className.indexOf("special") >= 0 ) &&
                <div className="post-sapo">
                  {showDescription && tile.post && tile.post.description}
                </div>
              }
              <div className={isMobile ? classes.chiplistMobile : classes.chiplist}>
                <Chip label={index + 1} />
                <Chip
                  avatar={<Avatar>M</Avatar>}
                  label="Cố định"
                  color="secondary"
                />
                {tile.post.pr_type && tile.post.pr_type !== "0" && (
                  <Chip
                    icon={<BrightnessHighIcon />}
                    label={`${prTypes.find(el => (el.value !== '0' && el.value === tile.post.pr_type)).label}`}
                  />
                )}
                {tile.expiredAt && (
                  <>
                    <Chip
                      icon={<EventIcon />}
                      label={convertTime(tile.expiredAt)}
                    />
                    <Chip
                      icon={<IconComponent />}
                      label={TRANSLATE[tile.autoGetBy]}
                    />

                    {tile.tags && tile.tags.length > 0 && (
                      <>
                        {tile.tags.map((tag) => (
                          <Chip
                            key={`tag-${tag.label}`}
                            icon={<LocalOfferOutlinedIcon />}
                            label={tag.label}
                          />
                        ))}
                      </>
                    )}

                    {tile.category && (
                      <Chip
                        icon={<CategoryOutlinedIcon />}
                        label={tile.category.name}
                      />
                    )}

                    {tile.autoGetBy === "pageview" && tile.pageviewDuration && (
                      <Chip
                        icon={<SettingsBackupRestoreOutlinedIcon />}
                        label={`${tile.pageviewDuration} ngày trước`}
                      />
                    )}
                    {tile.duplicatePermission && (
                      <Chip icon={<FileCopyIcon />} label="Cho phép trùng" />
                    )}
                  </>
                )}
                {tile.nextPost && (
                  <p className="text-sm">Tiếp theo: {tile.nextPost.title}</p>
                )}
              </div>
            </CardContent>
          </CardActionArea>

          <ActionsCard 
            tile={tile}
            switchPositionTile={switchPositionTile}
            handleSwitchPosition={handleSwitchPosition}
          /> 
        </Card>
    </MobileView>
    </>
  );
};

const AutoPost = ({ className = "", tile, index, openSetting, config, switchPositionTile, handleSwitchPosition, showCate = true, showTime = true, showDescription = true }) => {
  const classes = useStyles();
  const IconComponent = icons[tile.autoGetBy];
  
  return (
    <>
      <BrowserView>
        <Card
          className={clsx(classes.root, {
            [tile.className]: tile.className,
          })}
        >
          <CardActionArea
            onClick={() => openSetting(tile, index)}
            className={clsx({
              [classes.horCard]: tile.cardType === "hor-card",
              [classes.verThumb]: tile.thumbType === "ver-thumb",
            })}
          >
            <CardMedia
              className={
                (tile.post && tile.post.have_video ? "have_video " : "") +
                classes.media
              }
              image={
                tile.post
                  ? resizeImage(
                      tile.thumbType === "ver-thumb"
                        ? tile.post.img_ver
                        : tile.post.img_hor,
                      tile.thumbSize || 300
                    )
                  : placeholderImgSrc
              }
              title="Bài viết tự động"
            />
            <CardContent className={classes.content}>
              {tile.post && tile.post.title && (
                <Typography
                  variant="body2"
                  component="h6"
                  className={classes.title}
                >
                  {tile.post.title}
                </Typography>
              )}

              <div className="d-flex align-items-end my-2 cate-time">
                {showCate && tile.post && tile.post.primary_category && (
                  <p className={classes.category}>
                    {filterCategory(config, tile.post.primary_category)}
                  </p>
                )}
                {showTime && tile.post && tile.post.publishedAt  && (
                  <p
                    className={classes.publishedAt}
                    dangerouslySetInnerHTML={{
                      __html: convertTime(tile.post.publishedAt),
                    }}
                  ></p>
                )}
              </div>
              {showDescription && (
                <div className="post-sapo">
                  {tile.post && tile.post.description}
                </div>
              )}
              <div
                className={isMobile ? classes.chiplistMobile : classes.chiplist}
              >
                <Chip label={index + 1} />
                {/*<Chip avatar={<Avatar>A</Avatar>} label="Tự động" color="primary" />*/}
                {tile.post &&
                  tile.post.pr_type &&
                  tile.post.pr_type !== "0" && (
                    <Chip
                      icon={<BrightnessHighIcon />}
                      label={`${prTypes.find(el => (el.value !== '0' && el.value === tile.post.pr_type)).label}`}
                    />
                  )}
                <Chip
                  icon={<IconComponent />}
                  label={TRANSLATE[tile.autoGetBy]}
                />
                {tile.tags && tile.tags.length > 0 && (
                  <>
                    {tile.tags.map((tag) => (
                      <Chip
                        key={`tag-${tag.label}`}
                        icon={<LocalOfferOutlinedIcon />}
                        label={tag.label}
                      />
                    ))}
                  </>
                )}
                {tile.category && (
                  <Chip
                    icon={<CategoryOutlinedIcon />}
                    label={tile.category.name}
                  />
                )}

                {tile.autoGetBy === "pageview" && tile.pageviewDuration && (
                  <Chip
                    icon={<SettingsBackupRestoreOutlinedIcon />}
                    label={`${tile.pageviewDuration} ngày trước`}
                  />
                )}

                {tile.duplicatePermission && (
                  <Chip icon={<FileCopyIcon />} label="Cho phép trùng" />
                )}
              </div>
            </CardContent>
          </CardActionArea>
        </Card>
      </BrowserView>
      <MobileView>
        <Card
          className={clsx(classes.root, {
            [tile.className]: tile.className,
          })}
        >
          <CardActionArea
            onClick={() => openSetting(tile, index)}
            className={clsx({
              [classes.horCardMobile]: tile.cardType === "hor-card",
              [classes.verThumb]: tile.thumbType === "ver-thumb" && tile.className.indexOf("top-2") < 0,
            })}
          >
            {tile.className &&
              (tile.className == "top-1" || tile.className.indexOf("top-2") >= 0 ||
                tile.className.indexOf("thumb-radius-0") >= 0 ||
                tile.className.indexOf("special") >= 0) && (
                <CardMedia
                  className={
                    (tile.post && tile.post.have_video ? "have_video " : "") +
                    classes.media
                  }
                  image={
                    tile.post
                      ? resizeImage(
                          tile.thumbMobileType === "ver-thumb"
                            ? tile.post.img_ver
                            : tile.post.img_hor,
                          tile.thumbSize || 300
                        )
                      : placeholderImgSrc
                  }
                  title="Bài viết tự động"
                />
              )}
            <CardContent className={classes.content}>
              {tile.post && tile.post.title && (
                <Typography
                  variant="body2"
                  component="h6"
                  className={classes.title}
                >
                  {tile.post.title}
                </Typography>
              )}

              <div className="d-flex align-items-end my-2 cate-time">
                {showCate && tile.post && tile.post.primary_category && (
                  <p className={classes.category}>
                    {filterCategory(config, tile.post.primary_category)}
                  </p>
                )}
                {showTime && tile.post && tile.post.publishedAt && (
                  <p
                    className={classes.publishedAt}
                    dangerouslySetInnerHTML={{
                      __html: convertTime(tile.post.publishedAt),
                    }}
                  ></p>
                )}
              </div>
              {tile.className &&
                tile.className != "top-1" && tile.className.indexOf("top-2") < 0 &&
                tile.className.indexOf("thumb-radius-0") < 0 &&
                tile.className.indexOf("special") < 0 && (
                  <div className="d-flex justify-content-between align-items-start mt-2">
                    <div className={classes.thumbMobile}>
                      <div className={classes.thumbHolderMobile}>
                        <CardMedia
                          className={
                            (tile.post && tile.post.have_video
                              ? "have_video "
                              : "") + classes.mediaMobile
                          }
                          image={
                            tile.post
                              ? resizeImage(
                                  tile.thumbMobileType === "ver-thumb"
                                    ? tile.post.img_ver
                                    : tile.post.img_hor,
                                  tile.thumbSize || 300
                                )
                              : placeholderImgSrc
                          }
                          title="Bài viết tự động"
                        />
                      </div>
                    </div>
                    {showDescription && (
                      <div className={classes.sapoMobile + " post-sapo"}>
                        {tile.post && tile.post.description}
                      </div>
                    )}
                  </div>
                )}
              {tile.className &&
                (tile.className == "top-1" || tile.className.indexOf("top-2") >= 0 ||
                  tile.className.indexOf("thumb-radius-0") >= 0 ||
                  tile.className.indexOf("special") >= 0) && (
                  <div className="post-sapo">
                    {showDescription && tile.post && tile.post.description}
                  </div>
                )}
              <div
                className={isMobile ? classes.chiplistMobile : classes.chiplist}
              >
                <Chip label={index + 1} />
                {/*<Chip avatar={<Avatar>A</Avatar>} label="Tự động" color="primary" />*/}
                {tile.post &&
                  tile.post.pr_type &&
                  tile.post.pr_type !== "0" && (
                    <Chip
                      icon={<BrightnessHighIcon />}
                      label={`${prTypes.find(el => (el.value !== '0' && el.value === tile.post.pr_type)).label}`}
                    />
                  )}
                <Chip
                  icon={<IconComponent />}
                  label={TRANSLATE[tile.autoGetBy]}
                />
                {tile.tags && tile.tags.length > 0 && (
                  <>
                    {tile.tags.map((tag) => (
                      <Chip
                        key={`tag-${tag.label}`}
                        icon={<LocalOfferOutlinedIcon />}
                        label={tag.label}
                      />
                    ))}
                  </>
                )}
                {tile.category && (
                  <Chip
                    icon={<CategoryOutlinedIcon />}
                    label={tile.category.name}
                  />
                )}

                {tile.autoGetBy === "pageview" && tile.pageviewDuration && (
                  <Chip
                    icon={<SettingsBackupRestoreOutlinedIcon />}
                    label={`${tile.pageviewDuration} ngày trước`}
                  />
                )}

                {tile.duplicatePermission && (
                  <Chip icon={<FileCopyIcon />} label="Cho phép trùng" />
                )}
              </div>
            </CardContent>
          </CardActionArea>
          
          <ActionsCard 
            tile={tile}
            switchPositionTile={switchPositionTile}
            handleSwitchPosition={handleSwitchPosition}
          />          
        </Card>
      </MobileView>
    </>
  );
};

function TileItem({
  className,
  tile,
  index,
  openSetting,
  config,
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  switchPositionTile,
  handleSwitchPosition,
  showCate,
  showTime,
  showDescription
}) {
  if (tile.type === "manual") {
    return (
      <DraggableWrapper
        draggable={draggable}
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
        id={tile.id}
      >
        <ManualPost
          className={className}
          tile={tile}
          index={index}
          openSetting={openSetting}
          config={config}
          switchPositionTile={switchPositionTile}
          handleSwitchPosition={handleSwitchPosition}
          showCate={showCate}
          showTime={showTime}
          showDescription={showDescription}
        />
      </DraggableWrapper>
    );
  }

  return (
    <DraggableWrapper
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      id={tile.id}
    >
      <AutoPost
        className={className}
        tile={tile}
        index={index}
        openSetting={openSetting}
        config={config}
        switchPositionTile={switchPositionTile}
        handleSwitchPosition={handleSwitchPosition}
        showCate={showCate}
        showTime={showTime}
        showDescription={showDescription}
      />
    </DraggableWrapper>
  );
}

export default connect(
  (store) => {
    return {
      config: store.config,
    };
  },
  (dispatch) => {
    return {
      // setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    };
  }
)(TileItem);
